module.exports = __webpack_public_path__ + "static/media/21.7f2f73df.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/21.png
// module id = 981
// module chunks = 0